import apiService from '../api/apiService';
import authService from '../api/auth/authService';

export default {
  install(Vue) {
    Vue.prototype.$api = apiService;
    Vue.prototype.$auth = authService;

    Vue.mixin({
      created() {
        if (this.handleNotifyEvent) {
          apiService.addListener('notifyEvent', this.handleNotifyEvent);
        }
        if (this.handleLoadingEvent) {
          apiService.addListener('loadingEvent', this.handleLoadingEvent);
        }
      },

      destroyed() {
        if (this.handleLoginEvent) {
          apiService.removeListener('loginEvent', this.handleLoginEvent);
        }
        if (this.handleLoadingEvent) {
          apiService.removeListener('loadingEvent', this.handleLoadingEvent);
        }
      }
    });
  }
};
